import { render, staticRenderFns } from "./chart-register-subcontractor-info.vue?vue&type=template&id=4f31fc53&scoped=true&lang=pug&"
import script from "./chart-register-subcontractor-info.vue?vue&type=script&lang=ts&"
export * from "./chart-register-subcontractor-info.vue?vue&type=script&lang=ts&"
import style0 from "./chart-register-subcontractor-info.vue?vue&type=style&index=0&id=4f31fc53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31fc53",
  null
  
)

export default component.exports